export let audioHighlight = {
    highlight: function (audioElement) {
        const childNodes = [...audioElement.childNodes];

        childNodes.forEach(function (node) {
            if (isTextNode(node)) {
                if (!isEmptyTextNode(node)) {
                    highlightTextNode(node);
                }
            } else {
                if (!isEmptyHtmlNode(node)) {
                    highlightHtmlNode(node);
                }
            }
        });
    },
    unhighlight: function (audioElement) {
        const childNodes = [...audioElement.childNodes];

        childNodes.forEach(function (node) {
            if (isHighlightedTextNode(node)) {
                unhighlightTextNode(node);
            } else if (!isTextNode(node) && !isEmptyHtmlNode(node)) {
                unhighlightHtmlNode(node);
            }
        });
    },
};

function isTextNode(node) {
    return node.nodeName === '#text';
}

function isHighlightedTextNode(node) {
    return node.nodeName.toLowerCase() === 'mark';
}

function isEmptyTextNode(node) {
    return node.nodeValue.replaceAll('\n', '').trim() === '';
}

function isEmptyHtmlNode(node) {
    return node.innerHTML.trim() === '';
}

function highlightTextNode(node) {
    node.parentNode.innerHTML = `<mark>${node.nodeValue}</mark>`;
}

function unhighlightTextNode(node) {
    node.outerHTML = node.innerHTML;
}

function highlightHtmlNode(node) {
    node.innerHTML = `<mark>${node.innerHTML}</mark>`;
}

function unhighlightHtmlNode(node) {
    node.innerHTML = node.innerHTML.replace(/<mark>|<\/mark>/g, '');
}
